import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import TourJobFileRepository from "~/repository/TourJob/TourJobFileRepository";
import TourJobFile from "~/models/TourJob/TourJobFile";

class TourJobFileStore extends NestStore {
  rootStore = null;

  /**
   * @property {Array}
   */
  @observable tourJobFiles = [];

  /**
   * @property {TourJobFileRepository|null}
   */
  tourJobFileRepository = null;

  constructor(rootStore) {
    super();

    this.rootStore = rootStore;

    this.tourJobFileRepository = new TourJobFileRepository();
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    if (this.searchParams.tourId !== "") {
      params.tourId = this.searchParams.tourId;
    }

    return this.tourJobFileRepository.fetch(params).then(response => {
      this.processEntities(response.data.tourJobFiles);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(tourJobFiles = []) {
    this.tourJobFiles = [];

    tourJobFiles.forEach(tourJobFileArray => {
      const tourJobFile = new TourJobFile(tourJobFileArray);

      this.tourJobFiles.push(tourJobFile);
    });
  }

  @action
  getTourJobFileDownloadUrl(tourJobFileId) {
    return this.tourJobFileRepository.getDownloadUrl(tourJobFileId);
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.tourId = "";
  }
}

export default TourJobFileStore;
